<template>
  <div class="container">
    <d-pageedit 
      v-model="g"
      canadd
      title="Shops"
      :search="getsearch()"
      :params="params"
      :margintop="80"
      @clear="clear($event)"
      @load="load($event)"
      @del="del($event)"
      @save="save($event)"
    >
      <div v-if="g.cod">
        <div class="row mt-3">
          <div class="col-sm-9">
            <div class="row">
              <d-input v-model="g.des" type="text" label="Description" />
            </div>
            <div class="row mt-3">
              <d-auth v-model="g.admins" label="adminstrators" admins users groups />
              <d-auth v-model="g.auth" label="users" admins users groups />
            </div>
            <div class="row">
              <d-coddes v-model="g.grpdata" table="server2,HelperSearch,GRPDATA" label="Group Data" />
              <d-coddes v-model="g.brand" table="server2,HelperSearch,Brands" label="Brand" />
            </div>
            <div class="row">
              <d-coddes v-model="g.country" table="server2,HelperSearch,COUNTRIES" label="Country" />
              <d-coddes v-model="g.lang" table="server2,HelperSearch,Langs" label="Language" />
            </div>
            <div class="row">
              <d-input v-model="g.pricelist" type="text" small label="Price List" />
              <d-input v-model="g.customerid" type="text" small label="Custom ID1" />
            </div>
            <div class="row">
              <d-input v-model="g.customerid2" type="text" small label="Custom ID2" />
              <d-input v-model="g.customextra" type="text" small label="Extra" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="px-3">
              <code>Upload Image</code>
              <d-upload type="gen" :newname="newname" dim="256x256" :image="g.image" images height="250px" @loaded="changeimg($event)" /> 
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <d-input v-model="g.ind" type="text" small label="Address" />
          <d-input v-model="g.cap" type="text" small label="cap" />
          <d-input v-model="g.loc" type="text" small label="City" />
          <d-input v-model="g.prv" type="text" small label="prv" />
        </div>
        <div class="row">
          <d-input v-model="g.web" type="text" small label="web" />
          <d-input v-model="g.email" type="text" small label="email" />
          <d-input v-model="g.tel" type="text" small label="tel" />
          <d-input v-model="g.fax" type="text" small label="fax" />
        </div>
        <div class="row">
          <d-input v-model="g.formsocial" type="text" small label="form social" />       
          <d-input v-model="g.capital" type="text" small label="capital" />       
          <d-input v-model="g.codape" type="text" small label="codape" />       
          <d-input v-model="g.nsiret" type="text" small label="nsiret" />       
          <d-input v-model="g.intracom" type="text" small label="intracom" />       
        </div>  
        <div>
          <d-card title="Extra Data" expand class="mx-2 mt-4">
            <d-table :rows="g.extra" :cols="extracols" add editable @addelement="addextra($event)" />
          </d-card>
        </div>
      </div>
    </d-pageedit>
  </div>
</template>

<script>
import { NextApiClient as Dau } from '@3cad/nextcore';
export default {
  props: {
    params: String
  },
  data() {
    return {
      g: {},
      extracols: [
        {id:'cod',title:'code',w:1},
        {id:'des',title:'description',w:3},
      ]

    };
  },
  computed: {
     newname()  {
        return "S"+this.g.cod;
     }
  },
  methods: {
    changeimg(e) {
      console.log('chageimg',e);
      var x=e+"?"+Date.now();
      this.g.image=x;
      
    },
    addextra(e) {
       e.cod="";
       e.des="";
    },
    clear(e) {
      this.g={
         cod:'',
          grpdata:{cod:'002',des:'base'},
          country:{},
          lang:{},
          brand:{},
          extra:[],
          dests:[],
      }
    },
    load(e) {
      Dau.com("server2", "jGetShops", { cod: e.data.cod || "", dir: "" }, d => {
        this.g = d;
      });
    },
    save(e) {
      Dau.com("server2", "jSaveShops", { data:JSON.stringify(this.g) }, d => {
        this.g = d;
        e.callback({cod:this.g.cod});
      });
    },
    del(e) {
      Dau.com("server2", "DeleteShops", { cod: this.g.cod  }, d => {
         e.callback();
      })
      
      
    },
    getsearch() {
      return {
        service: "Server2",
        func: "HelperSearch",
        params: {
          Table: "Shops"
        }
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/erp/pages/adm/adminshops.vue